import { render, staticRenderFns } from "./HorsePopup.vue?vue&type=template&id=596c2c8f&"
import script from "./HorsePopup.vue?vue&type=script&lang=js&"
export * from "./HorsePopup.vue?vue&type=script&lang=js&"
import style0 from "./HorsePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HorsePopup.vue"
export default component.exports